import React from 'react';

export function PageHeader() {
  return <div>SignerAppPageHeader</div>;
}
